<template>

  <div class="input" >  
    <label>   
      <input
        type="checkbox"
        :name="inputName"
        :id="inputId"
        @focus="isFocused = true"
        @blur="isFocused = false"
        @change="change"
        v-model="checked"
        :required="required"
        :disabled="disabled"
        :value="value"
        data-testid="rmd-checkbox"
      />
      <span class="checkmark">

      </span>
      <div class="text">
        <slot name="label"></slot>
      </div>
    <br/>
    <span v-if="message" class="error">{{ message }}</span>
</label>

  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    name: String,
    id: String,
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: String,
    message: String,
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isFocused: false,
      inputId: "",
      inputName: "",
    };
  },
  computed: {
    checked: {
      get(): boolean {
        return this.modelValue;
      },
      set(value: boolean) {
        this.$emit('update:modelValue', value);
      }
    }
  },
  created() {
    this.inputId =
      this.id ||
      "id" + window.crypto.getRandomValues(new Uint32Array(1)).toString();
    this.inputName = this.name || this.inputId;
  },
  methods: {
    change(event: { target: HTMLInputElement }) {
      this.$emit("update:modelValue", event.target.checked);
      this.$emit("change", event.target.checked);
    },
  },
});
</script>


<style lang="scss" scoped>

.checkmark{
  display: none;
  position: absolute;
  width: 28px;
  height: 28px;
  left: 0;
  top:0;
  z-index: -1;
}
input[type="checkbox"]:focus  + .checkmark {
    border: 2px solid #9B89D0;
    display: inline-block;
}

.input {
  position: relative;
}

label {
  cursor: pointer;
}

label.isDisabled {
  cursor: not-allowed;
}

input[type="checkbox"] {
  cursor: pointer;
  margin-left: 6px;
  margin-top: 6px;
  height: 16px;
  width:16px;
}
label {
  align-items: center;
  cursor: pointer;
  user-select: none;
}

input[type="checkbox"]:hover {
  border: 2px solid #00469B;
  background-color: #E6F1F8;
  outline: none;
}

input[type="checkbox"]:focus {
 border: 2px solid #00469B;
 background: #E6F1F8;
  outline: none;
}


input[type="checkbox"]:checked {
  border: 2px solid #00469B;
  background: #00469B;
}

input[type="checkbox"]:checked::after {
  content: "";
  position: absolute;
  left: 3px;
  top: 0;
  width: 6px;
  height: 11px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
        
input[type="checkbox"] {
  appearance: none;
  display: inline-block;
  width: 16px;
  height: 16px;
  padding: 6px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  aspect-ratio: 1/1;
  position: relative;
  border: 2px solid #6E6E6E;
}

.text {
  margin-left: 12px;
  display: inline;
}

.error {
  font-weight: bold;
  color: $error-color;
}

// Safari bug currently with stroke-dashoffset, may want to change disappear to 40 -> 60
@keyframes appear {
  from {
    stroke-dashoffset: 60;
  }
  to {
    stroke-dashoffset: 40;
  }
}

@keyframes disappear {
  from {
    stroke-dashoffset: 40;
  }
  to {
    stroke-dashoffset: 60;
  }
}
</style>
